import { render } from 'preact'
import App from './App'
import './styles/index.css'

render(<App />, document.getElementById('app')!)
